import { useSyncExternalStore } from 'react';

import { createUpdateManager } from '../utils/pwa-updates';

const updates = createUpdateManager({ win: window, nav: navigator, doc: document, enabled: import.meta.env.PROD });

export function usePwaUpdates() {
  const state = useSyncExternalStore(updates.subscribe, updates.getSnapshot);
  return { ...state, apply: updates.apply, defer: updates.defer };
}
